/* eslint-disable import/no-anonymous-default-export */
import moment from "moment";
import Notification from "../../components/shared/Notification";
import { formatMonthYearDefault } from "../../helpers/formatDate";
import request from "../../helpers/request";
import { getUserEstablishment } from "./user";

export const submitReport = async (data, token) => {
  try {
    let establishmentId = await getUserEstablishment(token);
    return await request(token)
      .post(`/v2/inbound-monitoring/${establishmentId}/submit`, data)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }

        return data;
      });
  } catch (error) {
    console.log(error);
    return Notification(
      "Error",
      error.response.data.message || "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const getMonthlyReport = async (_data, token) => {
  try {
    return await request(token)
      .post(
        `v2/inbound-monitoring/${_data.establishmentId}/dl-monthly-occupancy-report`,
        {
          date: _data.date,
        }
      )
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          return Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }

        return data;
      });
  } catch (error) {
    return Notification(
      "Error",
      error.response.data.message || "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const getNationalReport = async (data, token) => {
  try {
    return await request(token)
      .post(
        `v2/inbound-monitoring/${data.establishmentId}/dl-monthly-occupancy-report`,
        {
          date: formatMonthYearDefault(data.date),
        }
      )
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          return Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }

        return data;
      });
  } catch (error) {
    return Notification(
      "Error",
      error.response.data.message || "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const getReportByDate = async (data, token) => {
  try {
    let date = moment(data.date).format("MM-DD-YYYY");
    return await request(token)
      .get(`v2/inbound-monitoring/${data.establishmentId}?date=${date}`)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    return Notification(
      error.response.data.message || "Some went wrong! Please try again later!",
      "",
      "error"
    );
  }
};
export const getRecentReports = async (establishmentId, token) => {
  try {
    return await request(token)
      .get(`v2/inbound-monitoring/recent/${establishmentId}/reports`)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    return Notification(
      error.response.data.message || "Some went wrong! Please try again later!",
      "",
      "error"
    );
  }
};

export const getDatesOfReports = async (establishmentId, token) => {
  try {
    return await request(token)
      .get(`/v2/inbound-monitoring/dates/report/${establishmentId}`)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const updateReport = async (data, token) => {
  try {
    let establishmentId = await getUserEstablishment(token);
    return await request(token)
      .put(`v2/inbound-monitoring/${establishmentId}/update`, data)
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }

        return data;
      });
  } catch (error) {
    return Notification(
      "Error",
      error.response.data.message || "Some went wrong! Please try again later!",
      "error"
    );
  }
};
